import { memo, useContext } from 'react';

import PersonContext from '@/pages/Person/PersonContext';
import DualTime from '@/ui/components/DualTime';

const PersonTreatmentWeekAndDay = () => {
  const {
    person: { episode_of_care, treatment_week_and_day }
  } = useContext(PersonContext);
  const [treatmentWeek, treatmentDay] = treatment_week_and_day;

  if (!episode_of_care) {
    return <span className="text-sm text-gray-500">No Episode of Care</span>;
  }

  return (
    <>
      {episode_of_care.admitted_at && <DualTime dateTime={new Date(episode_of_care.admitted_at)} />}
      {!episode_of_care.discharged_at && (
        <>
          , <strong className="text-sm">{`Week ${treatmentWeek} Day ${treatmentDay}`}</strong>
        </>
      )}
    </>
  );
};
export default memo(PersonTreatmentWeekAndDay);
